import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions";
import sampleCombine from 'xstream/extra/sampleCombine';

export function requestDepartmentsWithFilters(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_DEPARTMENTS_WITH_FILTERS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/departments' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestDepartmentsWithFilters',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDepartmentsWithFilters')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getDepartmentsWithFiltersSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDepartmentsWithFiltersFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDepartmentsWithFilters')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getDepartmentsWithFiltersFailed(response));

  return {
    ACTION: httpResponse$
  }
}


export function requestDepartments(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_DEPARTMENTS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/departments' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestDepartments',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDepartments')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getDepartmentsSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDepartmentsFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDepartments')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getDepartmentsFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/departments.js